import React, { useMemo } from 'react';
import GenericPullConfigListing from '../GenericPullConfigListing';
import UpGuardMappingForm from './UpGuardMappingForm';
import UpGuardCredentialsForm from './UpGuardCredentialsForm';
import { CellRenderers, columnRenderArrayData } from 'utils/tableUtils';

function UpGuardConfigListing(props) {

    const extraColumns = useMemo(() => [
        {
            title: "Vendor Name",
            dataIndex: "vendorName",
            width: 200,
            render: (text, record) => {
                return record.findingType === 'VENDORRISK' ? text : CellRenderers.VALUE_OR_NA();
            }
        },
        {
            title: "Labels",
            dataIndex: "labels",
            width: 200,
            render: (text, record) => {
                if(record.findingType === 'VENDORRISK') return CellRenderers.VALUE_OR_NA();
                if (record.findingType === 'BREACHRISK' && text) {
                    return columnRenderArrayData(text, record);
                }
                return 'All';
            }
        }
    ], []);

    return (
        <GenericPullConfigListing
        {...props}
        toolName={props.name}
        MappingForm={UpGuardMappingForm}
        CredentialsForm={UpGuardCredentialsForm}
        extraColumns={extraColumns}
     />
    )
}

export default UpGuardConfigListing;
